import { defineComponent, ref, useModel, openBlock, createElementBlock, Fragment, createVNode, unref, withModifiers, withCtx, renderList, normalizeClass, createElementVNode, toDisplayString, createCommentVNode, normalizeStyle, createBlock, mergeModels, nextTick, toRaw } from 'vue';
import { ElForm, ElInput, ElButton } from 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                */
import InfiniteScroll from '../../../component/infinite-scroll/infinite-scroll.js';
import _sfc_main$1 from '../../../component/player/player.vue.js';
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
import { Search } from '@element-plus/icons-vue';
import { SelectList, ListWrapper } from '@ssml-editor/vue';
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import { SoundContentData } from './data.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "sound-event-content",
  props: /* @__PURE__ */ mergeModels({
    categoryPageSize: { default: 10 },
    soundPageSize: { default: 10 },
    fetchSounds: { type: Function, default: () => Promise.resolve([]) },
    fetchCategories: { type: Function, default: () => Promise.resolve([]) },
    searchSounds: { type: Function }
  }, {
    "modelValue": {
      default: new SoundContentData()
    },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const showSearchResult = ref(false);
    const showSoundList = ref(false);
    const searchInput = ref("");
    const categoryDataList = ref([]);
    const soundDataList = ref([]);
    const searchSoundDataList = ref([]);
    const searchSound = ref();
    const soundContentData = useModel(__props, "modelValue");
    function generateMark(sound, soundDataList2) {
      for (const s of soundDataList2) {
        if (s.value === sound) {
          return s.label;
        }
      }
    }
    function searchInputHandler(value) {
      if (value.trim() === "") {
        showSearchResult.value = false;
        searchSoundDataList.value = [];
      } else {
        showSearchResult.value = true;
      }
    }
    function categoryValueChangeHandler() {
      showSoundList.value = false;
      nextTick(() => {
        showSoundList.value = true;
      });
    }
    async function fetchSoundList(page) {
      const sounds = await __props.fetchSounds({
        page,
        category: soundContentData.value.category
      });
      return sounds.map((item) => ({
        label: item.name,
        value: item.src
      }));
    }
    async function categoryChangeHandler(categoryData) {
      showSoundList.value = false;
      if (categoryData.length > 0) {
        categoryDataList.value = categoryData;
        if (!soundContentData.value.category || !categoryData.some(
          (item) => item.value === soundContentData.value.category
        )) {
          soundContentData.value.category = categoryData[0].value;
        }
        nextTick(() => {
          showSoundList.value = true;
        });
      }
    }
    async function soundChangeHandler(soundData) {
      if (soundData.length > 0) {
        soundDataList.value = soundData;
        if (!soundContentData.value.sound || !soundData.some((item) => item.value === soundContentData.value.sound)) {
          soundContentData.value.sound = soundData[0].value;
        }
      }
    }
    async function searchSubmitHandler() {
      searchSound.value = void 0;
      searchSoundDataList.value = [];
      const sounds = __props.searchSounds ? await __props.searchSounds({
        word: searchInput.value
      }) : [];
      if (sounds.length > 0) {
        searchSoundDataList.value = sounds.map((item) => ({
          label: item.name,
          value: item.src
        }));
        searchSound.value = sounds[0].src;
      }
    }
    function soundSelectHandler(item) {
      soundContentData.value.sound = item.value;
    }
    function searchSoundSelectHandler(item) {
      searchSound.value = item.value;
    }
    function getData() {
      let mark = void 0;
      if (showSearchResult.value) {
        if (searchSound.value) {
          mark = generateMark(searchSound.value, searchSoundDataList.value);
        }
        return { sound: searchSound.value, mark };
      } else {
        const data = toRaw(soundContentData.value);
        if (data.sound) {
          mark = generateMark(data.sound, soundDataList.value);
        }
        return { ...data, mark };
      }
    }
    __expose({
      getData
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        __props.searchSounds ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "se-sound-event-content-search"
        }, [
          createVNode(unref(ElForm), {
            onSubmit: withModifiers(searchSubmitHandler, ["prevent"])
          }, {
            default: withCtx(() => [
              createVNode(unref(ElInput), {
                modelValue: searchInput.value,
                "onUpdate:modelValue": ($event) => searchInput.value = $event,
                placeholder: "搜索声音",
                clearable: "",
                onInput: searchInputHandler
              }, {
                append: withCtx(() => [
                  createVNode(unref(ElButton), {
                    onClick: searchSubmitHandler,
                    icon: unref(Search)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          showSearchResult.value ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "se-sound-event-content-search-result"
          }, [
            createVNode(unref(SelectList), {
              modelValue: searchSound.value,
              "onUpdate:modelValue": ($event) => searchSound.value = $event,
              "data-list": searchSoundDataList.value
            }, {
              default: withCtx(({ model, dataList }) => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(dataList, (item, index) => {
                  return openBlock(), createElementBlock("p", {
                    class: normalizeClass(["se-sound-item", { activated: item.value === model }]),
                    title: item.label,
                    key: index,
                    onClick: ($event) => searchSoundSelectHandler(item)
                  }, [
                    createVNode(unref(_sfc_main$1), {
                      src: item.value.toString()
                    }, null, 8, ["src"]),
                    createElementVNode("span", { class: "se-text" }, toDisplayString(item.label), 1)
                  ], 10, ["title", "onClick"]);
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue", "data-list"])
          ])) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        createElementVNode("div", {
          class: "se-sound-event-content-body",
          style: normalizeStyle({ display: showSearchResult.value ? "none" : "flex" })
        }, [
          createVNode(unref(ListWrapper), { title: "类型" }, {
            default: withCtx(() => [
              createVNode(unref(InfiniteScroll), {
                modelValue: soundContentData.value.category,
                "onUpdate:modelValue": [($event) => soundContentData.value.category = $event, categoryValueChangeHandler],
                "page-size": __props.categoryPageSize,
                load: __props.fetchCategories,
                onChange: categoryChangeHandler
              }, null, 8, ["modelValue", "onUpdate:modelValue", "page-size", "load"])
            ]),
            _: 1
          }),
          createVNode(unref(ListWrapper), { title: "声音" }, {
            default: withCtx(() => [
              showSoundList.value ? (openBlock(), createBlock(unref(InfiniteScroll), {
                key: 0,
                modelValue: soundContentData.value.sound,
                "onUpdate:modelValue": ($event) => soundContentData.value.sound = $event,
                "page-size": __props.soundPageSize,
                load: fetchSoundList,
                onChange: soundChangeHandler
              }, {
                default: withCtx(({ model, dataList }) => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(dataList, (item, index) => {
                    return openBlock(), createElementBlock("p", {
                      class: normalizeClass(["se-sound-item", { activated: item.value === model }]),
                      title: item.label,
                      key: index,
                      onClick: ($event) => soundSelectHandler(item)
                    }, [
                      createVNode(unref(_sfc_main$1), {
                        src: item.value.toString()
                      }, null, 8, ["src"]),
                      createElementVNode("span", { class: "se-text" }, toDisplayString(item.label), 1)
                    ], 10, ["title", "onClick"]);
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onUpdate:modelValue", "page-size"])) : createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 4)
      ], 64);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=sound-event-content.vue2.js.map
